import { Outlet } from 'react-router-dom';

import { Analytics } from './analytics';
import { AutomationStatusBanner } from './automation-status-banner';
import { ChannelsSection } from './channels-section';
import { GeneralRecommendation } from './general-recommendations';
import { PerformanceStatusBanner } from './performance-status-banner';

export function Channels() {
  return (
    <>
      <AutomationStatusBanner />
      <PerformanceStatusBanner />
      <Analytics />
      <GeneralRecommendation />
      <ChannelsSection />
      <Outlet />
    </>
  );
}
